import { createContext } from 'react';
import { noopCleanup } from '../cleanup';
export const UntilContext = /*#__PURE__*/createContext({
  subscribe: () => noopCleanup,
  value: {
    current: true
  }
});